import React from "react";
import { Route } from "react-router-dom";
import Blogs from "../components/index";

const BlogsRoutes = () => {
  return (
    <>
      <Route path="/blogs" element={<Blogs />} /> 
    </>
  );
};

export default BlogsRoutes;
